import { hydrateFromMariaDB } from './dbBridge';
import { prDatabase, MASTER_ITEMS, auditLogsDatabase } from './mockPrStore';
import { poDatabase, SUPPLIER_MASTER } from './mockPoStore';
import { grDatabase, inventoryCostLayerDatabase, inventoryTransactionDatabase } from './mockGrStore';
import { itemDatabase } from './mockItemStore';
import { supplierDatabase } from './mockSupplierStore';
import { uomDatabase } from './mockUomStore';
import { warehouseDatabase } from './mockWarehouseStore';

let hydrationPromise: Promise<void> | null = null;

export function ensureDatabaseHydrated(): Promise<void> {
  if (!hydrationPromise) {
    hydrationPromise = hydrateFromMariaDB({
      prDatabase,
      poDatabase,
      grDatabase,
      costLayers: inventoryCostLayerDatabase,
      inventoryTxs: inventoryTransactionDatabase,
      itemDatabase,
      masterItems: MASTER_ITEMS,
      supplierDatabase,
      supplierMaster: SUPPLIER_MASTER,
      uomDatabase,
      warehouseDatabase,
      auditLogs: auditLogsDatabase,
    }).catch((err) => {
      console.error('[initDatabase] Failed to hydrate database from MariaDB:', err);
    });
  }
  return hydrationPromise;
}

// Auto-trigger on server side load
if (typeof window === 'undefined') {
  ensureDatabaseHydrated();
}
